import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import DropdownIcon from '@material-ui/icons/ArrowDropDown';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import DashboardIcon from '@material-ui/icons/Dashboard';
import MenuIcon from '@material-ui/icons/Menu';
import UsersIcon from '@material-ui/icons/SupervisorAccount';
import PhotosIcon from '@material-ui/icons/CameraAlt';
import SwipesIcon from '@material-ui/icons/CompareArrows';
import HeartIcon from '@material-ui/icons/Favorite';
import MessageIcon from '@material-ui/icons/Message';
import ReportedIcon from '@material-ui/icons/Report';

import styled from './AppFrameStyles';

import { actions as authActions } from '../../services/auth';
import { ListItemIcon } from '@material-ui/core';

import logoImg from './logo.png';

class AppFrame extends React.Component {
  state = {
    userMenuAnchorEL: null,
    mobileDrawerOpen: false
  };

  handleUserMenuOpen = event => {
    this.setState({ userMenuAnchorEL: event.currentTarget });
  };

  handleUserMenuClose = () => {
    this.setState({ userMenuAnchorEL: null });
  };

  handleDrawerOpen = () => {
    this.setState({
      mobileDrawerOpen: true
    });
  };

  handleDrawerClose = () => {
    this.setState({
      mobileDrawerOpen: false
    });
  };

  logout = () => {
    this.handleUserMenuClose();
    this.props.actions.logout();
  };

  render() {
    const { classes, children, user, container, title } = this.props;
    const userMenuOpen = Boolean(this.state.userMenuAnchorEL);

    const drawer = (
      <div>
        <div className={classes.logoContainer}>
          <img src={logoImg} className={classes.logo} alt="Kuku" />
        </div>
        <Divider />
        <List>
          <ListItem
            button
            component={Link}
            to="/"
            onClick={this.handleDrawerClose}
          >
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/users"
            onClick={this.handleDrawerClose}
          >
            <ListItemIcon>
              <UsersIcon />
            </ListItemIcon>
            <ListItemText primary="Users" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/photos"
            onClick={this.handleDrawerClose}
          >
            <ListItemIcon>
              <PhotosIcon />
            </ListItemIcon>
            <ListItemText primary="Photos" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/swipes"
            onClick={this.handleDrawerClose}
          >
            <ListItemIcon>
              <SwipesIcon />
            </ListItemIcon>
            <ListItemText primary="Swipes" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/matches"
            onClick={this.handleDrawerClose}
          >
            <ListItemIcon>
              <HeartIcon />
            </ListItemIcon>
            <ListItemText primary="Matches" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/messages"
            onClick={this.handleDrawerClose}
          >
            <ListItemIcon>
              <MessageIcon />
            </ListItemIcon>
            <ListItemText primary="Messages" />
          </ListItem>

          <ListItem
            button
            component={Link}
            to="/reports"
            onClick={this.handleDrawerClose}
          >
            <ListItemIcon>
              <ReportedIcon />
            </ListItemIcon>
            <ListItemText primary="Reported Users" />
          </ListItem>
        </List>
        {/* <Divider />
        <List>
          {['All mail', 'Trash', 'Spam'].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List> */}
      </div>
    );

    return (
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerOpen}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              {title}
            </Typography>

            {user && (
              <Button
                color="inherit"
                onClick={this.handleUserMenuOpen}
                className={classes.navButton}
              >
                {user.firstName}
                <DropdownIcon />
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <Menu
          id="menu-appbar"
          anchorEl={this.state.userMenuAnchorEL}
          open={userMenuOpen}
          onClose={this.handleUserMenuClose}
          classes={{
            paper: classes.menu
          }}
        >
          <MenuItem onClick={this.logout}>Logout</MenuItem>
        </Menu>
        <nav className={classes.drawer}>
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              open={this.state.mobileDrawerOpen}
              onClose={this.handleDrawerClose}
              classes={{
                paper: classes.drawerPaper
              }}
              ModalProps={{
                keepMounted: true // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>
          <div className={classes.toolbarPadding} />
          {children}
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.data.token ? state.auth.data : null,
    title: state.app.title
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    logout: () => dispatch(authActions.logout())
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(AppFrame))
);
